import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { XtLocale, Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import XtDropdown, { ListItemProps } from "@/components/Xt/Dropdown";
import { DropdownProps, Avatar } from "antd";

interface CountryDropdownProps extends BaseCompProps {
  attr?: any;
  value?: string | number;
  selectProps?: string;
  placement?: DropdownProps["placement"];
  label?(item?: ListItemProps): React.ReactNode;
  onChange?(value: CountryDropdownProps["value"], item: ListItemProps): void;
}
const { useTranslation } = Hooks;
const CountryDropdown: React.FC<CountryDropdownProps> = ({ className, selectProps = "xtId", value, placement = "bottomLeft", label, onChange }) => {
  const t = useTranslation();
  const { user } = store;
  // useMemo
  const getList = useMemo(() => {
    // 老接口获取国家列表
    const newList = user.countryList?.map((item) => {
      const displayName = XtLocale.intl.code !== "cn" && item.nameEn ? item.nameEn : item.name;
      const desSuffix = item.des && item.des !== displayName ? ` [${item.des}]` : "";
      return {
        ...item,
        dropKey: item[selectProps],
        dropName: `+${item.code} [${displayName}]${desSuffix}`,
        meta: true,
        dropAvatar: <Avatar src={item.nationalFlagIcon}></Avatar>,
      } as ListItemProps;
    });

    return newList;
  }, [user.countryList]);

  return (
    <XtDropdown
      list={getList}
      value={value}
      label={(item) => {
        return label ? (
          label(item)
        ) : !item ? (
          <span>{t("account.SelectCountry")}</span>
        ) : (
          <>
            <Avatar src={item?.nationalFlagIcon}></Avatar>
            <span className="text-ellipsis">
              {item?.dropName}
            </span>
          </>
        );
      }}
      placement={placement}
      onChange={onChange}
      className={cx("bar", styles["country-drop"], className)}
      search
      searchIconPosition="end"
      // getPopupContainer={"body"}
    ></XtDropdown>
  );
};
export default observer(CountryDropdown);
